import Rest from './Rest';

export class UserService {

  static async viewProfile(userId) {
    return Rest.post(`/view-profile`, { user_id: userId })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching user profile', error);
        throw error;
      });
  }

  static async updateUser(userDetails) {
    return Rest.post(`/update-profile`, userDetails)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error updating user profile', error);
        throw error;
      });
  }

  static async getUserMenus(userDetails) {
    return Rest.post(`/user/menus`, userDetails)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching user menus', error);
        throw error;
      });
  }

  static async userAlerts(userId) {
    return Rest.post(`/alerts-list`, { user_id: userId })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching alerts', error);
        throw error;
      });
  }

  static async updateAlerts(alertDetails) {
    return Rest.post(`/update-user-alerts`, alertDetails)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error updating alerts', error);
        throw error;
      });
  }


  static async changePassword(params) {
    return Rest.post(`/change-password`, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error while changing password', error);
        throw error;
      });
  }


  static async addAddress(params){
    return Rest.post(`/address/add`, params)
      .then(response =>{
        return response.data;
      })
      .catch(error =>{
        console.error('Error while adding address', error);
        throw error;
      })
  }

  static async updateAddress(params){
    return Rest.post(`/address/update`, params)
      .then(response =>{
        return response.data;
      })
      .catch(error =>{
        console.error('Error while updating address', error);
        throw error;
      })
  }

  static async deleteAddress(params){
    return Rest.post(`/address/delete`, params)
      .then(response =>{
        return response.data;
      })
      .catch(error =>{
        console.error('Error while deleting address', error);
        throw error;
      })
  }
}